import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { EventsProvider as Provider } from '@shapeable/ui';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const EVENTS_QUERY = graphql`
query NodeAllEventsQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Events" } }) {
    nodes {
      data
    }
  }
}
`;

export const EventsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={shapeableProviderValue(useStaticQuery(EVENTS_QUERY), 'items')}>{children}</Provider>;
};
